import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Instagram, BookText as TikTok } from 'lucide-react';
import Logo from './Logo';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white border-t">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Logo and About */}
          <div className="md:col-span-1">
            <Link to="/" className="inline-block mb-4">
              <Logo size="md" showText={true} />
            </Link>
            <p className="text-gray-600 mb-4">
              Inspiration, resources, and tools to help you grow your garden wherever you are in your journey.
            </p>
            <div className="flex space-x-4">
              <a href="https://instagram.com/theblohmstead" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-primary-500 transition-colors">
                <Instagram className="h-5 w-5" />
              </a>
              <a href="https://www.tiktok.com/@theblohmstead" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-primary-500 transition-colors">
                <TikTok className="h-5 w-5" />
              </a>
              <a href="mailto:erin@bloomagrows.com" className="text-gray-400 hover:text-primary-500 transition-colors">
                <Mail className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-gray-800 mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/plants" className="text-gray-600 hover:text-primary-600 transition-colors">
                  Plants
                </Link>
              </li>
              <li>
                <Link to="/collections" className="text-gray-600 hover:text-primary-600 transition-colors">
                  Garden Collections
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-gray-600 hover:text-primary-600 transition-colors">
                  Articles
                </Link>
              </li>
              <li>
                <Link to="/shop" className="text-gray-600 hover:text-primary-600 transition-colors">
                  Resources
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-600 hover:text-primary-600 transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <a href="https://garden.bloomagrows.com" className="text-gray-600 hover:text-primary-600 transition-colors">
                  Tutorials
                </a>
              </li>
              <li>
                <Link to="/fall-garden-club" className="text-gray-600 hover:text-primary-600 transition-colors">
                  Fall Garden Club
                </Link>
              </li>
              <li>
                <Link to="/subscribe" className="text-gray-600 hover:text-primary-600 transition-colors">
                  Subscribe
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold text-gray-800 mb-4">Garden Tools</h3>
            <ul className="space-y-2">
              <li>
                <a
                  href="https://plant.bloomagrows.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-600 hover:text-primary-600 transition-colors"
                >
                  Planting Calendar
                </a>
              </li>
              <li>
                <a
                  href="https://layout.bloomagrows.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-600 hover:text-primary-600 transition-colors"
                >
                  Garden Layouts
                </a>
              </li>
              <li>
                <a
                  href="https://wtf.bloomagrows.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-600 hover:text-primary-600 transition-colors"
                >
                  WTF is wrong with my plant?
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-500 text-sm mb-4 md:mb-0">
            &copy; {currentYear} Blooma. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}